<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="fetch" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-export</v-icon>
      Exportar
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="400" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-download</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Consumos OT</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Bitácora por Orden</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8">
          <v-avatar color="primary lighten-5" size="80" class="mb-6">
            <v-icon color="primary" size="40">fas fa-file-invoice-dollar</v-icon>
          </v-avatar>
          <div class="body-1 primary--text font-weight-bold mb-2">¡Datos Preparados!</div>
          <div class="caption grey--text px-4 mb-6">El reporte detallado de consumos por orden de trabajo está listo para descargar.</div>

          <vue-json-to-csv
            :json-data="items"
            :labels="labels"
            :csv-title="csvTitle"
            :separator="';'"
            @success="val => handleSuccess(val)"
            @error="val => handleError(val)">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar CSV
            </v-btn>
          </vue-json-to-csv>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import VueJsonToCsv from 'vue-json-to-csv'
import numeral from 'numeral'
import moment from 'moment'
import {fetchConsumtionBitacoraByOT} from '@/api/production'

export default {
  name: "ExportConsumeOTBitacora",
  props: ['options', 'disabled', 'filter'],
  components: { VueJsonToCsv },
  data() {
    return {
      loading: false,
      dataReady: false,
      items: [],
      labels: { 
        created_at: { title: 'Fecha' },
        transaction: { title: 'Transacción' },
        workorder_id: { title: 'OT' },
        customer_name: { title: 'Cliente' },
        article_sku: { title: 'Art. SKU' },
        article_name: { title: 'Articulo' },
        unit: { title: 'Unid. Compra' },
        articlePrice: { title: 'Precio Prom.' },
        unitConsume: { title: 'Unid. Consumo' },
        convertedPrice: { title: 'Precio Conv.' },
        qty: { title: 'Cantidad' },
        total: { title: 'Total' },
        created_by_full_name: { title: 'Usuario' },
      },
      csvTitle: `export_consume_ot_bitacora_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}`
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      var created_before = ''
      var created_after = ''
      if (this.filter.created_after) created_after = moment(this.filter.created_after).utc().format('yyyy-MM-DD HH:mm')
      if (this.filter.created_before) created_before = moment(this.filter.created_before).utc().add(1439, 'minutes').format('yyyy-MM-DD HH:mm')
      if (!this.filter.family) this.filter.family = ''
      
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      const query = `ordering=${sortDesc && sortDesc[0] ? sortBy[0] : '-' + (sortBy ? sortBy[0] : 'id')}&page=${page || 1}&created_after=${created_after}&created_before=${created_before}&article__family=${this.filter.family}`
      
      await fetchConsumtionBitacoraByOT(query)
        .then((data) => {
          this.items = data.results.map(i => {
            i.created_at = moment(i.created_at).format('DD-MM-YYYY')
            i.workorder_id = i.workorder.id
            i.customer_name = i.workorder.customer_name
            i.article_sku = i.article.sku
            i.article_name = i.article.name
            return i
          })
          this.dataReady = true
        })
        .catch((err) => notifications.showError(err))
        .finally(() => this.loading = false)
    },
    handleSuccess(val) {
      notifications.showSuccess('Reporte por OT Exportado')
      this.dataReady = false
    },
    handleError(val) {
      notifications.showError('Error Exportando Reporte por OT')
      this.dataReady = false
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; font-family: 'Outfit', sans-serif !important; }
.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.h-44 { height: 44px !important; }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.8px; }
</style>